import React, { ChangeEvent } from 'react';
import styles from './Checkbox.module.scss';
import CheckboxIcon from '../../assets/icons/checkbox.svg?react';
import CheckboxFillIcon from '../../assets/icons/checkbox_fill.svg?react';
import TextSpeech from '../text-speech/TextSpeech';

type Props = {
  id?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  touchable?: boolean;
  className?: string;
  needSpeak?: boolean;
  isAU?: boolean;
};

function Checkbox(props: Props) {
  const { checked, onChange, children, disabled, touchable, className, needSpeak, isAU=false } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    onChange(e.target.checked);
  };

  return (
    <label className={`${touchable ? [styles.touchableWrapper, checked ? styles.active : ''].join(' ') : [styles.wrapper, className].join(' ')} ${disabled ? styles.disabled : ''}`}
      onClick={(e) => {
        e.preventDefault();
        if (disabled) return;
        onChange(!checked);
      }}>
      {!touchable && (checked ? <CheckboxFillIcon/> : <CheckboxIcon/>)}
      {!touchable && (<input className={styles.input} type="checkbox" checked={checked} onChange={handleChange}/>)}
      {children && !props?.label ? children : <span className={styles.label}>{props.label}
        {needSpeak && <>
          <TextSpeech text={props.label ?? ''} isAU={isAU} />
        </>}
      </span>}
    </label>
  );
}

export default Checkbox;
